export const OG_IMAGE = "https://images.pexels.com/photos/31930001/pexels-photo-31930001.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const seo = {
  en: {
    home: {
      title: "World Rhubarb Association | Connecting the World Through Rhubarb",
      desc: "The World Rhubarb Association (世界ルバーブ協会) connects rhubarb growers, researchers, businesses and enthusiasts worldwide — growing the rhubarb industry and building its sustainable future.",
    },
    wrd: {
      title: "World Rhubarb Day Initiative | World Rhubarb Association",
      desc: "An open, honestly documented initiative to establish World Rhubarb Day — a global celebration of rhubarb, its growers, its culture and its future.",
    },
    transparency: {
      title: "Transparency & Governance | World Rhubarb Association",
      desc: "Organization facts, governance, documents and the zero-exaggeration manifesto of the World Rhubarb Association — founded 2026, verified data only.",
    },
    privacy: {
      title: "Privacy Policy | World Rhubarb Association",
      desc: "How the World Rhubarb Association collects, uses and protects personal information, including the Global Rhubarb Database and international processing.",
    },
    survey: {
      title: "Global Rhubarb Database Survey | World Rhubarb Association",
      desc: "Answer the Global Rhubarb Database survey — a consent-based record of the world's rhubarb growers, varieties, production and organizations.",
    },
    keywords: "World Rhubarb Association, Rhubarb, 世界ルバーブ協会, ルバーブ, rhubarb growers, rhubarb network, World Rhubarb Day, rhubarb industry",
  },
  ja: {
    home: {
      title: "世界ルバーブ協会(WRA)| ルバーブで世界をつなぐ",
      desc: "世界ルバーブ協会(World Rhubarb Association)は、世界中のルバーブ生産者・研究者・企業・愛好家をつなぎ、ルバーブ産業の発展と持続可能な未来を創る国際プロジェクトです。",
    },
    wrd: {
      title: "世界ルバーブの日イニシアチブ | 世界ルバーブ協会",
      desc: "「世界ルバーブの日」の制定を目指す、オープンで誠実なイニシアチブ。ルバーブと、その生産者、文化、未来を祝う世界的な日へ。",
    },
    transparency: {
      title: "透明性とガバナンス | 世界ルバーブ協会",
      desc: "世界ルバーブ協会の組織情報・ガバナンス・公開文書・誇張ゼロのマニフェスト。2026年創設、検証済みデータのみ。",
    },
    privacy: {
      title: "プライバシーポリシー | 世界ルバーブ協会",
      desc: "世界ルバーブ協会が収集する個人情報、その目的、Global Rhubarb Databaseでの利用、国外での処理、訂正・削除の受付について。",
    },
    survey: {
      title: "Global Rhubarb Database アンケート | 世界ルバーブ協会",
      desc: "Global Rhubarb Databaseアンケートに回答——同意に基づく、世界のルバーブ生産者・品種・生産・組織の記録。",
    },
    keywords: "世界ルバーブ協会, ルバーブ, World Rhubarb Association, Rhubarb, ルバーブ生産者, 世界ルバーブの日, ルバーブ産業",
  },
  pl: {
    home: {
      title: "World Rhubarb Association | Łączymy świat poprzez rabarbar",
      desc: "World Rhubarb Association (世界ルバーブ協会) łączy producentów rabarbaru, naukowców, firmy i entuzjastów na całym świecie — rozwija branżę i buduje jej zrównoważoną przyszłość.",
    },
    wrd: {
      title: "Inicjatywa Światowego Dnia Rabarbaru | World Rhubarb Association",
      desc: "Otwarta, uczciwie dokumentowana inicjatywa ustanowienia Światowego Dnia Rabarbaru — globalnego święta rabarbaru, jego producentów, kultury i przyszłości.",
    },
    transparency: {
      title: "Przejrzystość i zarządzanie | World Rhubarb Association",
      desc: "Fakty o organizacji, zarząd, dokumenty i manifest zero przechwałek World Rhubarb Association — założona w 2026, tylko zweryfikowane dane.",
    },
    privacy: {
      title: "Polityka prywatności | World Rhubarb Association",
      desc: "Jak World Rhubarb Association zbiera, wykorzystuje i chroni dane osobowe — w tym Globalną Bazę Danych Rabarbaru i przetwarzanie międzynarodowe.",
    },
    survey: {
      title: "Ankieta Globalnej Bazy Danych Rabarbaru | World Rhubarb Association",
      desc: "Wypełnij ankietę Globalnej Bazy Danych Rabarbaru — oparty na zgodach rejestr producentów, odmian, produkcji i organizacji rabarbarowych świata.",
    },
    keywords: "World Rhubarb Association, Rhubarb, rabarbar, 世界ルバーブ協会, producenci rabarbaru, Światowy Dzień Rabarbaru, branża rabarbarowa",
  },
};
